<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="odd; else loader">
    <div style="float: right">
      <app-copy-entity-link
        [link]="'/odds/' + odd.guid"
      ></app-copy-entity-link>
    </div>
    <h1 class="mat-display-1" style="text-align: center">
      {{ odd?.name ?? "" }}
    </h1>
    <div *ngIf="!odd">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="odd">
      <div style="flex: 1; display: flex">
        <div style="flex: 1">
          <p><strong>Guid : </strong>
            {{ odd.guid }}
            <app-copy-entity-data
              [data]="'' + odd.guid"
            ></app-copy-entity-data>
          </p>
          <p><strong>Type de cote : </strong>{{ odd.oddType?.name ?? "N/A" }}</p>
          <p><strong>Match : </strong>{{ odd.event?.name ?? "N/A" }}</p>
          <p><strong>Nom : </strong>{{ odd.name }}</p>
          <p><strong>Valeur de la cote : </strong>{{ odd.value }}</p>
          <p><strong>Header : </strong>{{ odd.header ?? "N/A" }}</p>
          <p><strong>Résultat : </strong>{{ odd.result }}</p>
        </div>
      </div>
      <mat-divider style="margin: 10px 0"></mat-divider>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Retour</button>
</mat-dialog-actions>

<ng-template #loader>
  <div class="spinner-wrapper">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
</ng-template>
